export default {"src":"/_next/static/image/public/images/ic_myprofile_blue_vertical_menu.20781859297833abee3c80720ef559a8.svg","height":20,"width":20};